import styles from './ErrorBoundary.module.css';
import React, { Component, ErrorInfo } from 'react';
import { NavigateFunction } from 'react-router-dom';

interface Props {
  children: React.ReactNode;
  navigate: NavigateFunction;
  translate: Function;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, info);
  }

  handleHomeClick = () => {
    this.setState({ hasError: false });
    this.props.navigate('/');
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className={styles.container}>
          <div className={styles.wrapper}>
            <p>System Error</p>
            <p>Not to worry. We&apos;re working on it.</p>
            <span onClick={this.handleHomeClick}>
              {this.props.translate('home_label')}
            </span>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
